import React from 'react';
import styles from './TableRso.module.scss';
import { formatCellValue } from '../../../utils/formatCellValue';
import { useDisplayedRows } from '../../../hooks/useDisplayedRows';
import { nameTableRows } from '../../../constants/nameTableRso';
import { useSelector } from 'react-redux';

const TableRso = ({ form }) => {
  const { getFieldValue } = form;

  const { data, columnLabels, highlightedColumns } = useSelector(
    (state) => state.rsoImportStore
  );

  const displayedRows = useDisplayedRows(data);
  const dataStartLineValue = getFieldValue(nameTableRows.firstRow);

  return (
    <div className={styles.tableContainer}>
      <div className={styles.scrollWrapper}>
        <table>
          <thead>
            <tr>
              <th></th>
              {columnLabels.map((label, index) => {
                const highlight = highlightedColumns.find((item) =>
                  item.column.some((elem) => elem === label.value)
                );
                return (
                  <th
                    key={index}
                    style={{
                      backgroundColor: highlight
                        ? highlight.color
                        : 'transparent',
                    }}
                  >
                    {label.value}
                  </th>
                );
              })}
            </tr>
            <tr>
              <th>№</th>
              {Object.keys(data[0]).map((header, index) => {
                const highlight = highlightedColumns.find((item) =>
                  item.column.some((elem) => elem === columnLabels[index].value)
                );
                return (
                  <th
                    key={index}
                    style={{
                      backgroundColor: highlight
                        ? highlight.color
                        : 'transparent',
                    }}
                  >
                    {header}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {displayedRows?.map((row, rowIndex) => (
              <tr key={rowIndex}>
                <td>{dataStartLineValue + rowIndex}</td>
                {Object.values(row).map((cell, cellIndex) => {
                  const highlight = highlightedColumns.find((item) =>
                    item.column.some(
                      (elem) => elem === columnLabels[cellIndex].value
                    )
                  );
                  return (
                    <td
                      key={cellIndex}
                      style={{
                        backgroundColor: highlight
                          ? highlight.color
                          : 'transparent',
                      }}
                    >
                      {formatCellValue(cell)}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableRso;
